module.exports = __webpack_public_path__ + "media/src/components/Navigation/NotificationHeader/img/premiumMobileBrandPink-d2d5b45c2cdc3d1e74ba6859bf193331.png";